import { configureStore } from "@reduxjs/toolkit";
import authSlice from "../slices/authSlice";
import userAuthSlice from "../slices/userAuthSlice";

// eslint-disable-next-line import/prefer-default-export
export const store = configureStore({
	reducer: {
		auth: authSlice,
		userAuth: userAuthSlice,
	},
});
